import {useEffect} from 'react';

export default function usePersistReportSelection({reportId, projectSiren, location, setSelectedProject, setReportSelectedFoldersSirens, projects}) {
  useEffect(() => {
    if (reportId) localStorage.setItem('reportId', reportId);
    if (projectSiren) localStorage.setItem('projectSiren', projectSiren);
  }, [location.state]);

  useEffect(() => {
    if (projectSiren && projects) {
      const project = projects.find(p => p.siren === projectSiren);
      if (project) {
        setReportSelectedFoldersSirens([projectSiren]);
        setSelectedProject(project);
      }
    }
  }, [projectSiren, projects]);

  useEffect(() => {
    if (!location.pathname.startsWith('/reports')) {
      localStorage.removeItem('reportId');
      localStorage.removeItem('projectSiren');
      setSelectedProject(null);
      setReportSelectedFoldersSirens([]);
    }
  }, [location.pathname]);
}
